import styled from 'styled-components';
import { BLACK, BLUE_RIBBON_300, BLUE_RIBBON_900, GRAYSCALE_300, LIGHT_LAVENDER } from '../../styles/colors';
import { GIVONIC, INTER } from '../../styles/fonts';

// Styled container
export const InputContainer = (styled.div<{ $isActive: boolean; $displayOnly?: boolean }>`
  display: flex;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E5E7EB;
  height: 42px;
  width: 100%;
  transition: all 0.2s ease-in-out;
  opacity: ${({ $displayOnly }) => $displayOnly ? '0.9' : '1'};
  cursor: ${({ $displayOnly }) => $displayOnly ? 'default' : 'pointer'};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// Styled number container
export const NumberContainer = (styled.div<{ $isActive: boolean; $displayOnly?: boolean }>`
  display: flex;
  width: 36px;
  height: 100%;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  font-family: ${GIVONIC.regular};
  font-weight: 100;
  font-size: 13px;
  background-color: ${({ $isActive, $displayOnly }) => {
    if ($displayOnly) return LIGHT_LAVENDER;
    return $isActive ? BLUE_RIBBON_300 : LIGHT_LAVENDER;
  }};
  color: ${BLUE_RIBBON_900};
  transition: all 0.2s ease-in-out;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// Styled input
export const StyledInput = (styled.input<{ $disabled: boolean }>`
  flex: 1;
  min-width: 0;
  border: none;
  padding: 0 16px 0 6px;
  font-family: ${({ $disabled }) => ($disabled ? INTER.semiBold : INTER.regular)};
  font-size: ${({ $disabled }) => ($disabled ? '15px' : '13px')};
  color: ${BLACK};
  outline: none;
  font-weight: ${({ $disabled }) => {
    if ($disabled) return 600;
    return 400;
  }};
  background-color: transparent;

  &::placeholder {
    color: ${GRAYSCALE_300};
  }

  text-transform: lowercase;

  &:disabled {
    color: inherit;
    opacity: 0.8;
    cursor: default;
  }
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
